import Processors from './processors';

const CustomMessage = {
    process: (customMessage) => {
        if (customMessage.payload) {
            const processor = Processors.getProcessor(customMessage.payload.command);
            if (processor) {
                processor.exec(customMessage);
            }
        }
        return customMessage;
    }
};

export default CustomMessage;
